// extracted by mini-css-extract-plugin
export default {"default-location-warning":"DefaultLocationWarning_default-location-warning__3kbNa"};